import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { routeNames } from '../../routes'
import alertIcon from '../../assets/icons/alert.svg'
import emailIcon from '../../assets/icons/email-green.svg'
import './MobileAlert.sass'

const emailLink = `mailto:?subject=Gulf TREE&body=Learn more about Gulf TREE at ${window.location.href}`

class MobileAlert extends Component {
  state = {
    isOpen: true
  }

  constructor() {
    super()
    this._closeOverlay = this.closeOverlay.bind(this)
    this._renderContent = this.renderContent.bind(this)
  }

  closeOverlay() {
    this.setState({ isOpen: false })
  }

  renderContent(isOpen, pathname) {
    switch (pathname) {

      // Display different mobile alert if on filtered search
      case routeNames.filteredSearch:
        return (
          <div className="mobile-alert-overlay-content">
            <img src={alertIcon} alt="alert icon" />
            <h5>The Gulf TREE is a robust search tool and is optimized for desktop. The mobile version provides a list of tools. To use the tools, please email a link to yourself to open on desktop.</h5>
            <a
              className="header-btn"
              href={emailLink}
              rel="noopener noreferrer"
              target="_top"
            >
              <img src={emailIcon} alt="email" />
              <h5>send yourself a link to view gulf tree on desktop</h5>
            </a>
          </div>
        )

      default:
        return (
          <div className="mobile-alert-overlay-content">
            <img src={alertIcon} alt="alert icon" />
            <h5>The Gulf TREE is optimized for desktop, so keep that in mind while browsing on mobile.</h5>
            <button
              type="button"
              aria-label="close"
              className="btn-transparent-orange-sm"
              onClick={this._closeOverlay}
            >
              view mobile version
            </button>
          </div>
        )
    }
  }

  render() {
    const { isOpen } = this.state
    const { pathname } = this.props

    return (
      <section className={`mobile-alert-overlay overlay-slidedown ${isOpen && 'open'}`}>
        <button
          type="button"
          aria-label="close"
          className="close-btn"
          onClick={this._closeOverlay}
        >
          &#10005;
        </button>
        {this._renderContent(isOpen, pathname)}
      </section>
    )
  }
}

MobileAlert.propTypes = {
  pathname: PropTypes.string
}

export default MobileAlert
